import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getIsSoundsEnabledForCurrentUser } from './soundEnabledSelector';
import { playSound } from './soundService';
import { SoundId } from './soundConstants';

/**
 * Returns a `play(soundId)` callback that respects the sounds feature flag.
 * Use this from components; use soundMiddleware for redux-action-driven sounds.
 */
export const usePlaySound = () => {
    const isSoundsEnabled = useSelector(getIsSoundsEnabledForCurrentUser);

    return useCallback(
        (soundId: SoundId) => {
            if (!isSoundsEnabled) return;
            playSound(soundId);
        },
        [isSoundsEnabled],
    );
};
